import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

import CreateDivision from '../Dialogs/CreateDivision';

const DivisionSelector = ({ selected=[], onSelectionChange=() => {}, isEditable = true}) => {
  const classes = useStyles();
  const divisions = useSelector(state => Object.values(state.divisions.byId).filter(division => !division.isDeleted));
  const [showCreateDivision, setShowCreateDivision] = useState(false);

  const handleClick = divisionId => {
    if (selected.includes(divisionId)) {
      return onSelectionChange(selected.filter(id => id !== divisionId));
    } else {
      return onSelectionChange([ ...selected, divisionId ]);
    }
  }

  const handleCreateDivision = () => setShowCreateDivision(true);

  if(divisions.length !== 0) {
    return (
      <div className={classes.chipContainer}>
        {
          divisions.map(
            division => {
              const { displayName, divisionId } = division;
              return (
                <Chip
                  id={divisionId}
                  key={divisionId}
                  className={classes.chip}
                  color={selected.includes(divisionId) ? 'primary' : 'default'}
                  label={displayName}
                  onClick={() => handleClick(divisionId)}
                  disabled={!isEditable}
                />
              )
            }
              
          )
        }
      </div>
    )
  } else {
    return (
      <>
        <div className={classes.root}>
          <Button
            color='primary'
            onClick={handleCreateDivision}
          >
            Create a division
          </Button>  
        </div>
        {
          showCreateDivision && (
            <CreateDivision 
              isOpen={showCreateDivision}
              onClose={setShowCreateDivision}
            />
          )
        }
      </>
    )
  }
  
};

const useStyles = makeStyles(theme => ({
  chip: {
    margin: theme.spacing(1),
  },
  chipContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
}));

export default DivisionSelector;